import React, { useState } from "react";

// Import hooks and utils
import {
  getImageName,
  getExtension
} from "@/utils/fallbacks/imageMetaFallbacks";

// Import react skeleton
import Skeleton from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css';

// Import inhouse icons
import { Image, Eye } from "../icons_new";

export default function ImageCard ({
    img,
    isSelected,
    onToggle,
    onPreview,
}) {
    const [loadFailed, setLoadFailed] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    return (
        <div
          className={`group flex flex-col items-center justify-center h-[200px] w-fit px-[1em] rounded-[10px] gap-[0.5em] cursor-pointer ${
            isSelected ? "bg-[#f5f5f5] hover:bg-[#e9e9e9]" : "hover:bg-[#f5f5f5]"
          } hover:scale-[1.01]`}
          onClick={onToggle}
        >
          {/* Image container */}
          <div className="relative w-[100px] h-[100px] rounded-[7px] overflow-hidden border border-[#e8e8e8] p-[0.2em]">
            {/* Skeleton while loading */}
            {isLoading && (
              <Skeleton
                aria-hidden="true"
                height={100}
                width={100}
                borderRadius={7}
                baseColor="#e4e4e4"
                highlightColor="#f5f5f5"
                className="absolute top-0 left-0 w-full h-full transition-opacity duration-300 opacity-100"
              />
            )}

            {/* Fallback or image */}
            {loadFailed || !img.url ? (
              <div className="w-full h-full flex items-center justify-center bg-[#f3f3f3] rounded-[7px]">
                <Image className="w-6 h-6 text-[#ccc]" />
              </div>
            ) : (
              <img
                src={img.url}
                alt={img.alt || getImageName(img)}
                onLoad={() => setIsLoading(false)}
                onError={() => {
                  setIsLoading(false);
                  setLoadFailed(true);
                }}
                className={`w-full h-full object-cover rounded-[7px] transition-opacity duration-300 ${
                  isLoading ? "opacity-0" : "opacity-100"
                }`}
              />
            )}

            {/* Preview icon */}
            {!loadFailed && !isLoading && (
              <div
                onClick={(e) => {
                  e.stopPropagation();
                  onPreview();
                }}
                className="absolute bottom-[6px] right-[6px] p-[4px] rounded-md bg-[#000] hover:bg-[#3c3c3c] transition-all opacity-0 group-hover:opacity-100"
              >
                <Eye className="w-4 h-4 text-white" />
              </div>
            )}

            {/* Checkbox */}
            {!isLoading && (
              <input
                type="checkbox"
                checked={isSelected}
                readOnly
                className="absolute top-[8px] left-[8px] h-[17px] w-[20px] accent-[#000]"
              />
            )}
          </div>
        
          {/* Info section */}
          <div className="flex flex-col max-w-[100px] text-[15px] text-[#3d3d3d] truncate">
            {isLoading ? (
              <Skeleton
                height={10}
                width={80}
                borderRadius={4}
                baseColor="#e4e4e4"
                highlightColor="#f5f5f5"
              />
            ) : (
              <>
                <span className="font-medium">{getImageName(img)}</span>
                <span className="uppercase text-center text-[#000]">
                  {getExtension(img)}
                </span>
              </>
            )}
          </div>
        </div>
    );
};